<template>
    <app-dialog
        :busy="loading"
        :open="open"
        :title="title"
        size="sm"
        @close="$emit('close')"
    >
        <p v-if="deletable" class="text-sm leading-6 text-gray-500">
            {{ confirmationText }}
        </p>
        <template v-else>
            <p class="text-sm leading-6 text-gray-500">
                Der Löschschutz ist aktiv, weil noch folgende Verwendungen bestehen:
            </p>
            <div v-if="blockers.length" class="mt-5 overflow-hidden rounded border border-bordergray-100">
                <div
                    v-for="blocker in blockers"
                    :key="blocker.key"
                    class="flex items-center justify-between gap-4 border-t border-bordergray-100 px-4 py-3 text-sm text-gray-700 first:border-t-0"
                >
                    <span class="min-w-0">{{ blocker.label }}</span>
                    <span class="whitespace-nowrap">{{ blocker.count }}</span>
                </div>
            </div>
            <p v-else class="mt-3 text-sm leading-6 text-gray-500">
                Dieser Datensatz ist systemseitig geschützt und kann nicht gelöscht werden.
            </p>
        </template>

        <template v-if="deletable" #footer>
            <app-dialog-action
                label="Löschen"
                variant="danger"
                :loading="loading"
                @click="$emit('confirm')"
            />
        </template>
    </app-dialog>
</template>

<script>
import AppDialog from '@/components/modals/app-dialog.vue';
import AppDialogAction from '@/components/modals/app-dialog-action.vue';

export default {
    name: 'delete-guard-dialog',
    components: {AppDialog, AppDialogAction},
    props: {
        open: {type: Boolean, default: false},
        title: {type: String, required: true},
        confirmationText: {type: String, required: true},
        deletable: {type: Boolean, default: false},
        blockers: {type: Array, default: () => []},
        loading: {type: Boolean, default: false},
    },
    emits: ['close', 'confirm'],
};
</script>
